import {useIntl} from 'react-intl'
import {Link} from 'react-router-dom'
import {CSSTransition} from 'react-transition-group'
import {ROUTES} from '../../../../_gori/constants/_routes'
import AuthService from '../core/_requests'
import {useState} from 'react'
import useCancelToken from '../../../../_gori/hooks/UseCancelToken'
import {isUndefined} from 'lodash'
import clsx from 'clsx'
import {Button} from '../../../../_gori/partials/widgets'
import {StorageHelpers} from '../../../../_gori/helpers'

export function PendingActivation() {
  const intl = useIntl()
  const {newCancelToken, isCancel} = useCancelToken()
  const [loading, setLoading] = useState(false)
  const [statusForm, setStatusForm] = useState<
    {status: 'success' | 'error'; message: string} | undefined
  >(undefined)

  const resendVerificationEmail = async () => {
    setStatusForm(undefined)
    try {
      setLoading(true)
      const config = {cancelToken: newCancelToken()}
      let payload = {
        identifier: StorageHelpers.getItemLocalStorage('REGISTERED_EMAIL') || '',
      }

      const response = await AuthService.resendVerificationEmail(payload, config)
      if (response) {
        setStatusForm({
          status: 'success',
          message: intl.formatMessage({id: 'ENTER_VERIFICATION_ACCOUNT_SENT'}),
        })
      }
    } catch (error: any) {
      if (isCancel(error)) return
      setStatusForm({
        status: 'error',
        message: intl.formatMessage({id: 'SEND_VERIFICATION_ACCOUNT_ERROR'}),
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <CSSTransition appear in timeout={300} classNames='fade' unmountOnExit>
      <div className='pending-activation-container d-flex flex-column align-items-center bg-white w-100 rounded shadow-sm p-15'>
        <div className='text-center mb-10 w-100'>
          <h1 className='pending-activation-title m-0 fw-bolder lh-base'>
            {intl.formatMessage({id: 'VERIFY_YOUR_EMAIL'})}
          </h1>
        </div>

        {!isUndefined(statusForm) && (
          <div
            className={clsx('mb-10 alert w-100', {
              'bg-light-primary': statusForm.status === 'success',
              'alert-danger': statusForm.status === 'error',
            })}
          >
            <div className='alert-text font-weight-bold text-center'>{statusForm.message}</div>
          </div>
        )}

        <div className='pending-activation-alert-text d-flex m-0 rounded p-3 mb-10'>
          <div>{intl.formatMessage({id: 'ACCOUNT_VERIFICATION_INSTRUCTION'})}</div>
        </div>

        <div className='w-100'>
          <Link
            to={ROUTES.AUTH.LOGIN}
            className='link-primary w-100'
            onClick={(e) => {
              if (loading) e.preventDefault()
            }}
          >
            <button
              type='submit'
              id='gori_sign_in_submit'
              disabled={loading}
              className='resend-email-verification d-block w-100 fs-5 fw-500 btn btn-lg btn-advanced-primary mx-auto'
            >
              {intl.formatMessage({id: 'SIGN_IN'})}
            </button>
          </Link>
          <Button
            id='resend_email_verification'
            className='d-block w-100 text-primary-deep text-hover-primary fs-5 fw-500 btn btn-lg rounded px-3 py-4 mx-auto'
            label={intl.formatMessage({id: 'RESEND_EMAIL_VERIFICATION'})}
            loadingText={intl.formatMessage({id: 'RESEND_EMAIL_VERIFICATION'})}
            loading={loading}
            disabled={loading}
            event={resendVerificationEmail}
          />
        </div>
      </div>
    </CSSTransition>
  )
}
